'use strict';

var _            = require('underscore');
var $            = require('jquery');
var Core         = require('../core/core.js');
var Theme        = require('../theme/theme.js');
var TabSubNav    = require('./tab__subnav.js');
var Window       = require('../window/window.js');
var Sidebar      = require('../sidebar/sidebar.js');
var Split        = require('../split/split.js');
var Switcher     = require('../switcher/switcher.js');
var EditorHolder = require('../editorHolder/editorHolder.js');
var Toolbar      = require('../toolbar/toolbar.js');
var Form         = require('../form/form.js');

/**
 * Creates a Tab
 *
 * @class
 */

class Tab extends Core {

	_defaults() {
		return {
			target: '.js-tab',
			fields: {}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class='editor__tab'>
				<div class='js-editor__tab__subnav'></div>
                <div class='editor__tab__yield js-editor__tab__yield'>
                    <div class='js-editor__tab__toolbar'></div>
                </div>
			</div>
		`;

		super.render();
	}

    /**
     * Add an Editor Holder to the tab
     */
    addEditorHolderTemplate(){
        return new EditorHolder({
            target: $('.js-editor__tab__yield', this.$el)
        });
    }

	/**
	 * Adds a submenu to the tab
	 */
	addSubNav(){
        $('.js-editor__tab__yield', this.$el).addClass('editor__tab__yield--sub');
		return new TabSubNav({
			target: $('.js-editor__tab__subnav', this.$el)
		});
	}

	/**
	 * Adds a draggable window to the tab
	 * @param {String} title - the title of the window
	 */
	addWindow(title){
		return new Window({
			target: $('.js-editor__tab__yield', this.$el),
			fields: {
				'title': title
			}
		});
	}

    /**
     * Adds a toolbar to the tab
     */
    addToolbar(){
        return new Toolbar({
            target: $('.js-editor__tab__toolbar', this.$el)
        });
    }

    /**
     * Adds a sidebar to the tab
     */
    addSidebar(){
        return new Sidebar({
            target: $('.js-editor__tab__yield', this.$el)
        });
    }

    /**
     * Adds a split view for 2 or more editors
     */
    addSplit(width){
        return new Split({
            target: $('.js-editor__tab__yield', this.$el),
            width: width
        });
    }

    /**
     * Adds a footprint switcher to the right side
     */
    addSwitcher(canNotEdit){
        return new Switcher({
            target: $('.js-editor__tab__yield', this.$el),
            fields: {
                'canNotEdit': canNotEdit
            }
        });
    }

    /**
     * Adds a footprint switcher to the right side
     */
    addForm(){
        return new Form({
            target: $('.js-editor__tab__yield', this.$el)
        });
    }

	/**
	 * Set the tab active, eg make it visible
	 */
	setActive(){
		$(this.$el).css('opacity', '1');
        $(this.$el).css('visibility', 'visible');
	}

	/**
	 * Set the tab inactive, eg make it invisible
	 */
	setInactive(){
		$(this.$el).css('opacity', '0');
        $(this.$el).css('visibility', 'hidden');
	}

    /**
     * Set the tab theme
     */
    setTheme(theme){
        Theme(theme, this.$el);
    }

    /**
     * Make scrollable
     */
    makeScrollable(){
        $('.js-editor__tab__yield', this.$el).css('overflow', 'auto');
    }

}
module.exports = Tab;